<template>
  <div id="choose-receipt-container" :class="{ 'smaller-margins': cartSummaryInPdaDesktop }">
    <div id="choose-receipt-internal-container">
      <h5
        v-if="!hideReceiptOptions"
        :class="{ 'smaller-fonts': (cartSummaryInPdaDesktop && $screen.width < 1397)}"
        id="receipt-title"
      >
        <font-awesome-icon
          icon="cash-register"
          style="margin-right: 4px; margin-bottom:1px; color: #006adb"
        />
        {{selectedTable && selectedTable.typeOfReceipt=='FINAL_RECEIPT' ? 'Να βγεί τελική απόδειξη;' : selectedTable && selectedTable.typeOfReceipt=='TEMP_RECEIPT' ? 'Να βγεί προσωρινή απόδειξη;' : 'Να βγεί απόδειξη;'}}
      </h5>
      <div v-if="!hideReceiptOptions" id="receipt-options">
        <div
          class="receipt-option prevent-select"
          @click="selectPublishReceipt(false)"
          style="margin-right: 20px;"
        >
          <input
            v-if="selectedTable.type!='HOTEL_ROOM' || (selectedTable.type=='HOTEL_ROOM' && (!hotelizerIntegrationEnabled || (hotelizerIntegrationEnabled && hotelizerReceipt!='ON_CREDIT')))"
            class="receipt-option-radio-input"
            :class="{ 'smaller-height': (cartSummaryInPdaDesktop && $screen.width < 1397)}"
            type="radio"
            :value="false"
            v-model="willPublishReceipt"
            @change="onselectPublishReceipt"
          />
          <h6
            v-if="selectedTable.type!='HOTEL_ROOM' || (selectedTable.type=='HOTEL_ROOM' && (!hotelizerIntegrationEnabled || (hotelizerIntegrationEnabled && hotelizerReceipt!='ON_CREDIT')))"
            class="receipt-option-title"
            :class="{ selectedBolder: !willPublishReceipt, 'smaller-fonts': (cartSummaryInPdaDesktop && $screen.width < 1397) }"
          >Όχι</h6>
        </div>
        <div class="receipt-option" @click="selectPublishReceipt(true)">
          <input
            class="receipt-option-radio-input"
            :class="{ 'smaller-height': (cartSummaryInPdaDesktop && $screen.width < 1397)}"
            type="radio"
            :value="true"
            v-model="willPublishReceipt"
            @change="onselectPublishReceipt"
          />
          <h6
            class="receipt-option-title prevent-select"
            :class="{ selectedBolder: willPublishReceipt, 'smaller-fonts': (cartSummaryInPdaDesktop && $screen.width < 1397)}"
          >
            Ναι
            <div
              v-if="selectedTable && selectedTable.typeOfReceipt=='FINAL_RECEIPT' && willPublishReceipt"
              class="receipt-option"
              style="margin-left: 6px;"
            >
              |
              <input
                class="invoice-input-check"
                :class="{ 'smaller-height': (cartSummaryInPdaDesktop && $screen.width < 1397)}"
                v-model="isInvoice"
                style="margin-left:6px"
                type="checkbox"
              />
              <h6
                class="invoice-option-title"
                @click="toggleIsInvoice()"
                :class="{'smaller-fonts': (cartSummaryInPdaDesktop && $screen.width < 1397) }"
              >Τιμολόγιο</h6>
            </div>
          </h6>
        </div>
      </div>
      <h5
        v-if="hideReceiptOptions"
        :class="{ 'smaller-fonts': (cartSummaryInPdaDesktop && $screen.width < 1397), 'mb-0': true}"
        id="receipt-title"
      >
        <font-awesome-icon
          icon="cash-register"
          style="margin-right: 4px; margin-bottom:1px; color: #198b4a"
        />Θα βγει απόδειξη αναγκαστικά λόγω πληρωμής με κάρτα σε POS
      </h5>
      <div
        v-if="selectedTable && selectedTable.typeOfReceipt=='FINAL_RECEIPT' && hideReceiptOptions && willPublishReceipt"
        class="receipt-option"
        style="margin-left: 0px; margin-top:2px"
      >
        <input v-model="isInvoice" class="invoice-input-check" type="checkbox" />
        <h6
          class="invoice-option-title prevent-select"
          @click="toggleIsInvoice()"
          :class="{'smaller-fonts': (cartSummaryInPdaDesktop && $screen.width < 1397) }"
        >Τιμολόγιο</h6>
      </div>

      <div id="invoice-info-container" v-if="isInvoice && willPublishReceipt">
        <div id="invoice-input-container">
          <h6 id="invoice-header">ΑΦΜ:</h6>
          <input id="invoice-input" v-model="vat" @input="clearErrors()" type="text" />

          <button id="search-company-button" @click="searchCompanyByVat()">
            <clip-loader v-if="ongoingAction" :loading="ongoingAction" size="10px" color="#ffffff" />
            <font-awesome-icon v-else icon="search" />
          </button>
        </div>
        <div id="invoice-input-container">
          <h6 id="invoice-header">Επωνυμία:</h6>
          <input id="invoice-input" v-model="companyName" @input="clearErrors()" type="text" />
        </div>
        <div id="invoice-input-container">
          <h6 id="invoice-header">Διεύθυνση:</h6>
          <input id="invoice-input" v-model="address" @input="clearErrors()" type="text" />
        </div>
        <div id="invoice-input-container">
          <h6 id="invoice-header">Πόλη:</h6>
          <input id="invoice-input" v-model="city" @input="clearErrors()" type="text" />
        </div>
        <div id="invoice-input-container">
          <h6 id="invoice-header">Τ.Κ:</h6>
          <input id="invoice-input" v-model="postalCode" @input="clearErrors()" type="text" />
        </div>

        <h6 id="receipt-input-error-msg" v-if="error">{{errorMessage}}</h6>
      </div>
    </div>
  </div>
</template>

<script>
import StoreApi from "../api/stores";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
export default {
  name: "ReceiptOrNot",

  props: ["cartSummaryInPdaDesktop", "hideReceiptOptions", "restaurantId", "selectedTable", "hotelizerIntegrationEnabled", "hotelizerReceipt"],
  components: {
    ClipLoader
  },
  data() {
    return {
      willPublishReceipt: false,
      isInvoice: false,
      ongoingAction: false,
      error: false,
      errorMessage: "",
      vat: null,
      companyName: null,
      address: null,
      city: null,
      postalCode: null,
    }
  },
  watch: {

  },
  computed: {
    language() {
      return this.$store.getters.getLanguage;
    },
    authToken() {
      return this.$store.getters.getUserAuthToken;
    },
    jwt() {
      return this.$store.getters.getUserJWT;
    }
  },
  methods: {
    selectPublishReceipt(willPublishReceipt) {
      this.clearErrors();
      this.willPublishReceipt = willPublishReceipt;
      if (!this.willPublishReceipt) {
        this.isInvoice = false;
      }
      this.$emit("change-publish-receipt-selection", this.willPublishReceipt)
    },

    onselectPublishReceipt() {
      this.clearErrors();
      if (!this.willPublishReceipt) {
        this.isInvoice = false;
      }
      this.$emit("change-publish-receipt-selection", this.willPublishReceipt)
    },

    toggleIsInvoice() {
      this.isInvoice = !this.isInvoice;
    },

    async searchCompanyByVat() {
      if (!this.ongoingAction) {
        this.error = false;
        this.errorMessage = '';
        this.companyName = null;
        this.address = null
        this.city = null;
        this.postalCode = null;

        if (this.vat == null || this.vat.trim().length < 9) {
          this.error = true;
          this.errorMessage = 'Συμπληρώστε τον 9ψήφιο ΑΦΜ'
          if (!this.cartSummaryInPdaDesktop) {
            try {
              document.getElementById('invoice-info-container').scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
              });
            } catch (error) {
              console.log("Could not scroll to receipt error msg")
            }
          }
          return;
        }

        this.ongoingAction = true;
        let response = await StoreApi.fetchCompanyByVat(this.restaurantId, this.vat, this.authToken, this.jwt);
        if (response.error) {
          this.ongoingAction = false;
          this.error = true;
          this.errorMessage = 'Κάτι πήγε λάθος κατά την αναζήτηση, σιγουρευτείτε πως το ΑΦΜ είναι σωστό και δοκιμάστε ξανά. Διαφορετικά εισάγετε όλα τα στοιχεία της εταιρείας χειροκίνητα.'
        } else {
          this.ongoingAction = false;
          if (response.searchResults != null && response.searchResults.length > 0) {
            let companyDetails = response.searchResults.find(searchResult => !searchResult.isBranch);
            if (companyDetails == null) {
              this.error = true;
              this.errorMessage = 'Κάτι πήγε λάθος κατά την αναζήτηση, σιγουρευτείτε πως το ΑΦΜ είναι σωστό και δοκιμάστε ξανά. Διαφορετικά εισάγετε όλα τα στοιχεία της εταιρείας χειροκίνητα.';
              return;
            }
            this.companyName = companyDetails.coNameEl;
            this.address = companyDetails.streetNumber != null ? companyDetails.street + " " + companyDetails.streetNumber : companyDetails.street;
            this.city = companyDetails.city;
            this.postalCode = companyDetails.zipCode;
          } else {
            this.error = true;
            this.errorMessage = 'Κάτι πήγε λάθος κατά την αναζήτηση, σιγουρευτείτε πως το ΑΦΜ είναι σωστό και δοκιμάστε ξανά. Διαφορετικά εισάγετε όλα τα στοιχεία της εταιρείας χειροκίνητα.'
          }
        }
      }
    },

    setErrorMsg(errorMessage) {
      this.error = true;
      this.errorMessage = errorMessage;
    },

    clearErrors() {
      this.error = false;
      this.errorMessage = "";
    },

    getInvoiceState() {
      if (this.isInvoice && this.willPublishReceipt && this.selectedTable && this.selectedTable.typeOfReceipt == 'FINAL_RECEIPT') {
        let invoiceState = {
          isInvoice: true,
          invoiceInfo: {
            vat: this.vat,
            companyName: this.companyName,
            address: this.address,
            city: this.city,
            postalCode: this.postalCode
          }
        }
        return invoiceState;
      }

      let invoiceState = {
        isInvoice: false,
        invoiceInfo: null
      }
      return invoiceState;
    },

    resetState() {
      this.isInvoice = false;
      this.ongoingAction = false;
      this.error = false;
      this.errorMessage = "";
      this.vat = null;
      this.companyName = null;
      this.address = null;
      this.city = null;
      this.postalCode = null;
    }

  },
  mounted() {

  }
};
</script>

<style scoped>
#choose-receipt-container {
  width: 90%;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-bottom: 1vh;
  border-bottom: 1px solid rgba(116, 135, 150, 0.2);
  padding: 7.5px 0 7.5px 0;
  color: black;
}

.smaller-margins {
  margin-bottom: 0px !important;
  padding: 2px 0 1px 0 !important;
}

.selectedBolder {
  color: black;
  font-weight: 600;
}

#receipt-title {
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
}

#choose-receipt-internal-container {
  display: flex;
  flex-direction: column;
}

#receipt-options {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.prevent-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.receipt-option {
  display: flex;
  flex-direction: row;
  color: #6d6d6d;
  cursor: pointer;
}

.receipt-option-title {
  font-size: 14px;
  display: flex;
}

.invoice-option-title {
  font-size: 14px;
  font-weight: 700;
  color: #0275d8;
  margin-bottom: 0px;
}

.receipt-option-radio-input {
  accent-color: #198b4a;
  margin-bottom: 6px;
  margin-right: 5px;
  height: 22px;
}

.invoice-input-check {
  accent-color: #198b4a;
  margin-bottom: 0px;
  margin-right: 3px;
  height: 21px;
}

.smaller-height {
  height: 17px !important;
}

.mb-0 {
  margin-bottom: 0px !important;
}

.smaller-fonts {
  font-size: 12px !important;
  font-weight: 500 !important;
}

#invoice-input-container {
  width: 90%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
  color: black;
  margin-bottom: 0px !important;
  margin-top: 0px;
  padding: 2px 0 1px 0 !important;
}

#invoice-header {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
}

#invoice-input {
  margin-left: 4px;
  background-color: #ffffff;
  width: 100%;
  padding-left: 5px;
  padding-bottom: 1px;

  border-radius: 5px;
  margin-bottom: 5px;
  box-shadow: 1px 1px 3px rgb(146, 146, 146);
}

#search-company-button {
  padding: 4px 6px 4px 6px;
  border-radius: 6px;
  cursor: pointer;

  color: white;
  background-color: #006adb;
  font-size: 10px;
  font-weight: 600;
  margin-top: 0px !important;
  margin-left: 6px;
  margin-bottom: 5px;
}

#receipt-input-error-msg {
  font-size: 13px;
  font-weight: 600;
  color: #ee0800;
  margin-bottom: 0px;
}

@media screen and (max-width: 1397px) {
  #invoice-header {
    font-size: 12px;
    font-weight: 600;
  }

  #invoice-input {
    font-size: 12px;
  }
}
</style>